import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '@/utils/api';
import type { ChatRoom, ChatMessage } from '@/redux/slices/chatSlice';
import type { RootState } from '@/redux/Store';

export const fetchRooms = createAsyncThunk<ChatRoom[]>(
  'chat/fetchRooms',
  async () => {
    const { data } = await api.get('/chat/rooms');
    return data.rooms as ChatRoom[];
  }
);

export const fetchRoomMessages = createAsyncThunk<
  { roomId: string; messages: ChatMessage[]; hasMore: boolean; append: boolean },
  { roomId: string; append?: boolean },
  { state: RootState }
>(
  'chat/fetchRoomMessages',
  async ({ roomId, append = false }, { getState }) => {
    const state = getState();
    const cursor = append ? state.chat.cursorByRoom[roomId] : undefined;

    const params: Record<string, string | number> = { limit: 50 };
    if (cursor) params.before = cursor;

    const { data } = await api.get(`/chat/rooms/${roomId}/messages`, { params });
    return {
      roomId,
      messages: data.messages as ChatMessage[],
      hasMore: data.hasMore as boolean,
      append,
    };
  }
);


export const sendMegaphone = createAsyncThunk<
  ChatMessage,
  { body: string; txHash: string; roomId: string; scope: 'local' | 'global' }
>(
  'chat/sendMegaphone',
  async ({ body, txHash, roomId, scope }) => {
    const { data } = await api.post('/chat/megaphone', { body, txHash, roomId, scope });
    return data.message as ChatMessage;
  }
);

/**
 * Email-auth megaphone: the backend signs the KLV transfer with the user's
 * custodial wallet and broadcasts, then persists the message in one round-trip.
 */
export const executeMegaphone = createAsyncThunk<
  ChatMessage,
  { body: string; roomId: string; scope: 'local' | 'global' }
>(
  'chat/executeMegaphone',
  async ({ body, roomId, scope }) => {
    const { data } = await api.post('/chat/megaphone/execute', { body, roomId, scope });
    return data.message as ChatMessage;
  }
);
